import { SettingsAutoCheck } from 'features/settings/components/SettingsAutoCheck'
import { SettingsCalls } from 'features/settings/components/SettingsCalls'
import { SettingsDiagnostic } from 'features/settings/components/SettingsDiagnostic'
import { SettingsGroups } from 'features/settings/components/SettingsGroups'
import { SettingsProfile } from 'features/settings/components/SettingsProfile'
import { SettingsSecurity } from 'features/settings/components/SettingsSecurity'
import { PathsEnum } from 'pages/Paths'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { SettingsColumns } from '../../features/settings/components/SettingsColumns'
import { SettingsDataMaps } from '../../features/settings/components/SettingsDataMaps'
import { SettingsSampleData } from '../../features/settings/components/SettingsSampleData'
import { AccountSettingsPage } from './AccountSettingsPage'
import { getTntIdForNavigation } from 'utils/tenantUrlUtils'

export const AccountSettingsRouter = () => {
  const { tenantId } = useParams()
  const fallbackTenantId = tenantId || getTntIdForNavigation()

  return (
    <Routes>
      <Route path={PathsEnum.root} element={<AccountSettingsPage />}>
        <Route path={PathsEnum.accountSettingsProfile} element={<SettingsProfile />} />
        <Route path={PathsEnum.accountSettingsCalls} element={<SettingsCalls />} />
        <Route path={PathsEnum.accountSettingsAutoCheck} element={<SettingsAutoCheck />} />
        <Route path={PathsEnum.accountSettingsGroups} element={<SettingsGroups />} />
        <Route path={PathsEnum.accountSettingsSecurity} element={<SettingsSecurity />} />
        <Route path={PathsEnum.accountSettingsDiagnostic} element={<SettingsDiagnostic />} />
        <Route path={PathsEnum.accountSettingsColumns} element={<SettingsColumns />} />
        <Route path={PathsEnum.accountSettingsSampleData} element={<SettingsSampleData />} />
        <Route path={PathsEnum.accountSettingsDataMaps} element={<SettingsDataMaps />} />
        <Route
          path={PathsEnum.other}
          element={
            <Navigate
              to={
                fallbackTenantId
                  ? `/${fallbackTenantId}/account/${PathsEnum.accountSettings}`
                  : `/account/${PathsEnum.accountSettings}`
              }
            />
          }
        />
      </Route>
    </Routes>
  )
}
